import { ColorToken, UnlockStatus } from '@backrs_ui/common-ui';

// colors for status of overall unlock
export const UNLOCK_STATUS_COLOR_TOKENS: Record<UnlockStatus, ColorToken> = {
  not_yet: 'Error/400',
  developing: 'Warning/400',
  on_track: 'Success/400',
} as const;

export const getStatusColor = (status: UnlockStatus | null): ColorToken =>
  status ? UNLOCK_STATUS_COLOR_TOKENS[status] : 'Gray/400';
